import { ReactElement } from 'react';
import { IComponentJsScriptFields } from 'types/contentful';
import Script from 'next/script';

export default function JSScript({ jsScript }: IComponentJsScriptFields): ReactElement {
  const extractInlineJs = (raw: string): string => {
    if (!raw) return '';
    const scriptTagRegex = /<script[^>]*>([\s\S]*?)<\/script>/gi;
    const matches: string[] = [];
    let execResult: RegExpExecArray | null;
    while ((execResult = scriptTagRegex.exec(raw)) !== null) {
      const captured = (execResult[1] || '').trim();
      if (captured) matches.push(captured);
    }
    if (matches.length > 0) return matches.join('\n');
    // no <script> wrapper; return as-is but strip lone closing/opening tags if present
    return raw.replace(/<\/?script[^>]*>/gi, '').trim();
  };

  const code = extractInlineJs(jsScript || '');
  return (
    (code && (
      <Script
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: code,
        }}
      />
    )) || <></>
  );
}
